/**
 * API Configuration
 * Simple and reliable: uses environment variable if set, otherwise falls back to local dev
 *
 * IMPORTANT: For long-running operations (>60s), use LONG_RUNNING_API_URL which bypasses CloudFront
 * CloudFront has a 60s timeout limit, so operations like OpenAI requests must go direct to ALB
 */

/**
 * Get the API base URL (via CloudFront for <60s operations)
 * - Production: Uses REACT_APP_API_URL from .env.production (CloudFront)
 * - Development: Falls back to localhost:5001
 */
export const getApiUrl = () => {
  // If environment variable is set, use it (production deployments)
  if (process.env.REACT_APP_API_URL) {
    console.log(`[API Config] Using REACT_APP_API_URL: ${process.env.REACT_APP_API_URL}`);
    return process.env.REACT_APP_API_URL;
  }

  // Fallback for local development
  const protocol = window.location.protocol; // http: or https:
  const hostname = window.location.hostname; // localhost or IP address
  const apiPort = '5001'; // Backend always runs on 5001
  const apiUrl = `${protocol}//${hostname}:${apiPort}/api`;

  console.log(`[API Config] Frontend: ${window.location.origin}`);
  console.log(`[API Config] Backend (local dev): ${apiUrl}`);

  return apiUrl;
};

/**
 * Get the long-running API URL (direct to ALB, bypasses CloudFront 60s timeout)
 * - Production: Uses REACT_APP_LONG_API_URL from .env.production (direct ALB)
 * - Development: Same as regular API URL (no timeout issues locally)
 *
 * Use this for:
 * - Test case generation (OpenAI requests take >60s)
 * - Connector test/sync operations
 * - Any other operations that may take >60s
 */
export const getLongRunningApiUrl = () => {
  // In production, use dedicated long-running API URL if provided (direct ALB)
  if (process.env.REACT_APP_LONG_API_URL) {
    console.log(`[API Config] Using REACT_APP_LONG_API_URL: ${process.env.REACT_APP_LONG_API_URL}`);
    return process.env.REACT_APP_LONG_API_URL;
  }

  // Fallback to regular API URL (works fine for dev, and as fallback for prod)
  return getApiUrl();
};

// Export the current API URLs
export const API_URL = getApiUrl();
export const LONG_RUNNING_API_URL = getLongRunningApiUrl();

export default API_URL;
